<template>
  <div>
    <!--Breadcrumb button-->
    <breadcrumb-button>
      <template #items>
        <b-dropdown-item @click="openColumnsModal">
          <feather-icon
              icon="CheckSquareIcon"
              size="16"
          />
          <span class="align-middle ml-50">{{ $t('columns.self') }}</span>
        </b-dropdown-item>
      </template>
    </breadcrumb-button>

    <!--Filters-->
    <filter-card v-model="filter" v-bind:fields="filterFields" search/>

    <!-- Tabs with tables -->
    <b-card no-body>
      <b-card-header class="pb-50">
        <h5>{{ $t("menu.leads") }}</h5>
      </b-card-header>
      <b-card-body>
            <leads-table
                ref="leadTable1"
                v-bind:filters="filter"
                v-bind:columns="columns"
                :has-selection="false"
                :lazy="true"
            />

      </b-card-body>
    </b-card>

    <!--Modal-->
    <columns-modal ref="columns-modal" column-key="leads" v-model="columns"
                   v-bind:columns-names="columnsNames" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import BreadcrumbButton from '@/components/widget/breadcrumbButton'
import LeadSearchRequest from '@/model/lead/LeadSearchRequest'
import ColumnsModal from '@/components/modal/columnsModal'
import Lead from '@/model/lead/Lead'
import mixinPermissions from '@/components/mixin/mixinPermissions'
import mixinBase from '@/components/mixin/mixinBase'
import FilterCard from '@/components/widget/FilterCard'
import LeadFilterFields from '@/model/filter/LeadFilterFields'
import LeadsTable from '@/components/tables/LeadsTable'

export default {
  name: 'LeadsView',
  components: {
    LeadsTable,
    FilterCard,
    ColumnsModal,
    BreadcrumbButton
  },
  mixins: [mixinBase, mixinPermissions],
  data() {
    return {
      columnsNames: Object.keys(Lead()),
      filter: LeadSearchRequest(),
      filterLoaded: false,
      columns: [],
      filterFields: null,
    }
  },
  async created() {
    await this.refreshData()
    this.filterFields = LeadFilterFields()
  },
  computed: {
    ...mapGetters('data', ['allOrganizations']),
  },
  methods: {
    ...mapActions('lead', ['refreshData']),
    openColumnsModal() {
      this.$refs['columns-modal'].showModal()
    },

  }
}
</script>
